import { styled, css } from 'styled-components'

export const Progress = styled.div<{
  $finishProgressBar: boolean
  $uploadProgress: number
}>`
  width: 0;
  height: 100%;
  border-radius: 2px;
  background: ${({ theme }) => theme.colors.primary};

  ${({ $finishProgressBar, $uploadProgress }) =>
    $finishProgressBar
      ? css`
          width: 100%;
          transition: width 1s;
        `
      : css`
          width: ${$uploadProgress}%;
          transition: width 4s;
        `}
`
